"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConnectedTotalTokens = void 0;
var _react = require("react");
var _reactRedux = require("react-redux");
var _apiActions = require("../../redux/actions/apiActions");
var _digitalAssetsSelectors = require("../../redux/selectors/digitalAssetsSelectors");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var TotalTokensCount = function TotalTokensCount(props) {
  var InstrumentId = props.InstrumentId,
    ProductId = props.ProductId,
    getL2 = props.getL2;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    totalTokens = _useState2[0],
    setTotalTokens = _useState2[1];
  (0, _react.useEffect)(function () {
    if (InstrumentId && ProductId) {
      getL2(InstrumentId).then(function (data) {
        setTotalTokens(data.reduce(function (acc, curr) {
          if (curr[9] === 1) {
            return acc + curr[8];
          }
          return acc;
        }, 0));
      });
    }
  }, [InstrumentId, ProductId]);
  return totalTokens;
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getL2: function getL2(InstrumentId) {
      return dispatch((0, _apiActions.callAPI)('GetL2Snapshot', {
        OMSId: 1,
        Depth: 250,
        InstrumentId: InstrumentId
      })).then(function (res) {
        if (!res) return [];
        return res;
      });
    }
  };
};
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var InstrumentId;
  if (ownProps.InstrumentId) {
    InstrumentId = ownProps.InstrumentId;
  } else {
    InstrumentId = ((0, _digitalAssetsSelectors.selectedDigitalAssetInstrumentSelector)(state, {
      ProductId: ownProps.ProductId
    }) || {}).InstrumentId;
  }
  return _objectSpread({
    InstrumentId: InstrumentId
  }, ownProps);
};
var ConnectedTotalTokens = exports.ConnectedTotalTokens = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TotalTokensCount);